import { PRODUCT_LINE_CODE } from '../../../shared/constants/product-lines-codes';
import { cementBag } from './cement-bag';

export const crConfig = {
  [PRODUCT_LINE_CODE.BAG_CEMENT]: cementBag,
};
